import { render, staticRenderFns } from "./PersonCertification.vue?vue&type=template&id=47cdcc4c&scoped=true"
import script from "./PersonCertification.vue?vue&type=script&lang=js"
export * from "./PersonCertification.vue?vue&type=script&lang=js"
import style0 from "./PersonCertification.vue?vue&type=style&index=0&id=47cdcc4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cdcc4c",
  null
  
)

export default component.exports